import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getLineViaUnitID = (lineID: number | undefined): Promise<IGetDataLineViaUnitID[]> => {
  return axiosDefaultApi.get(`/api/ComLines/GetDataLineViaUnitID/DataLine/Unit/${lineID}`);
};

type QueryFnType = typeof getLineViaUnitID;

type UseGetLineViaUnitIDOptions = {
  lineID: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetLineViaUnitID = ({ lineID , config }: UseGetLineViaUnitIDOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getLineViaUnitID_${lineID}`],
    queryFn: () => getLineViaUnitID(lineID),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση της Γραμμής Data απο unit id.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};